import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: {},
  loading: false,
};

export const copyScheduleApiResponse = createAsyncThunk(
  "schedule/copySchedule",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.copySchedule(data)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);
export const copyScheduleSlice = createSlice({
  name: "copySchedule",
  initialState,
  reducers: {
    clearCopySchedule(state, action) {
      state.value = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(copyScheduleApiResponse.pending, (state) => {
        state.loading = true;
      })
      .addCase(copyScheduleApiResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(copyScheduleApiResponse.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const copyScheduleResponse = (state) => state.copySchedule.value;
export const {clearCopySchedule} = copyScheduleSlice.actions;

export default copyScheduleSlice.reducer;
